import { jsx as _jsx } from "react/jsx-runtime";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { ContactFetchListItem } from "../ContactFetchListItem";
export var ContactList = function (_a) {
    var _b = _a.contactIds, contactIds = _b === void 0 ? [] : _b, getSubtitle = _a.getSubtitle, getActions = _a.getActions;
    return (_jsx(Stack, { direction: "column", gap: 2, divider: _jsx(Divider, { orientation: "horizontal" }), children: (contactIds || []).filter(Boolean).map(function (contactId) { return (_jsx(ContactFetchListItem, { contactId: contactId, getSubtitle: getSubtitle, getActions: getActions })); }) }));
};
